// extracted by mini-css-extract-plugin
module.exports = {"container":"EarlyDocuments_container__XohXJ"};